module.exports = __webpack_public_path__ + "img/icon-lantern.aba6292c.png";